
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.852 6.081a3.348 3.348 0 00-.519-.424l-1.11 1.11a2 2 0 01.552 3.22l-2.56 2.559a2 2 0 11-2.828-2.828l.582-.582a4.02 4.02 0 01-.053-1.834L2.31 8.91a3.333 3.333 0 104.714 4.714l2.829-2.828a3.333 3.333 0 000-4.714z"}}),_c('path',{attrs:{"d":"M6.08 9.852c.162.162.336.303.52.425l1.11-1.111a2 2 0 01-.552-3.22l2.56-2.559a2 2 0 112.828 2.829l-.582.581c.159.6.176 1.228.052 1.834l1.607-1.607A3.333 3.333 0 108.909 2.31L6.081 5.138a3.333 3.333 0 000 4.714z"}})])
          )
        }
      }
    